import { IconButton } from "@fluentui/react";
import React from "react";
import { Toast, toast } from "react-hot-toast";

import { Text } from "../items/Text";
import { Stack } from "../layouts/stack/Stack";

export interface IconToastProps {
    toastItem: Toast;
    message: string;
}

export const IconToast: React.FunctionComponent<IconToastProps> = (props: IconToastProps) => {
    const { message, toastItem } = props;

    const handleClick = () => {
        toast.dismiss(toastItem.id);
    };

    return (
        <Stack>
            <Stack styles={{ root: { position: "absolute", top: 0, right: 0 } }}>
                <IconButton
                    styles={{
                        rootHovered: { backgroundColor: "transparent" },
                        rootPressed: { backgroundColor: "transparent" },
                        icon: { color: "black", fontSize: 12 }
                    }}
                    iconProps={{ iconName: "CalculatorMultiply" }}
                    onClick={handleClick}
                />
            </Stack>
            <Stack verticalAlign="center" horizontal={true} styles={{ root: { marginRight: 10 } }}>
                <Text testId="toast-message" nowrap={false} block={false} value={message} variant="medium" />
            </Stack>
        </Stack>
    );
};
